<template>
  <router-link
    :to="linkTo"
    class="link"
    :class="{
      'arrow-down': arrowDown,
      'arrow-up': !arrowDown,
      'red': theme === 'red',
      'blue': theme === 'blue',
      'green': theme === 'green',
    }"
  >
    <span v-html="text" />
    <img
      :src="require(`@/assets/image/pointer-${theme}.png`)"
      alt=""
      draggable="false"
    >
  </router-link>
</template>

<script>
export default {
  props: {
    theme: {
      type: String,
      default: 'red'
    },
    text: {
      type: String,
      required: true
    },
    arrowDown: {
      type: Boolean,
      default: false,
    },
    linkTo: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" scoped>
  .link {
    position: absolute;
    display: inline-block;
    border-radius: 0.3rem;
    padding: 0.42rem 0;
    width: 1.72rem;
    text-align: center;
    &.blue {
      background: #18489D;
    }
    &.red {
      background: #F15835;
    }
    &.green {
      background: #2FB779;
    }
    span {
      font-size: 0.56rem;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      writing-mode: vertical-rl;
      line-height: 1.2em;
      text-align: start;
    }
  }
  .link.arrow-up {
    img {
      width: 80%;
      position: absolute;
      left: 50%;
      top: 0;
      transform: translate(-50%, -95%);
    }
  }
  .link.arrow-down {
    img {
      width: 80%;
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translate(-50%, 95%) rotate(180deg);
    }
  }
</style>
